// extracted by mini-css-extract-plugin
export default {"change-plan-page":"ChangePlanPage_change-plan-page__p94OO"};